import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  makeStyles,
  Theme,
} from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  labelCell: {
    width: '40%',
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    borderBottom: '1px solid #E0E0E0',
    padding: theme.spacing(1.5, 2),
  },
  valueCell: {
    fontSize: '0.875rem',
    color: theme.palette.text.primary,
    borderBottom: '1px solid #E0E0E0',
    padding: theme.spacing(1.5, 2),
  },
  lastRow: {
    '& td': {
      borderBottom: 'none',
    },
  },
}));

const camelToLabel = (key: string) =>
  key.replace(/([A-Z])/g, ' $1').replace(/^./, c => c.toUpperCase());

export interface PlainJsonReviewTableProps {
  data: Record<string, any>;
  excludeFields?: string[];
}

export const PlainJsonReviewTable = ({ data, excludeFields = [] }: PlainJsonReviewTableProps) => {
  const classes = useStyles();
  const entries = Object.entries(data).filter(([key]) => !excludeFields.includes(key));

  return (
    <Table>
      <TableBody>
        {entries.map(([key, value], index) => (
          <TableRow key={key} className={index === entries.length - 1 ? classes.lastRow : ''}>
            <TableCell className={classes.labelCell}>{camelToLabel(key)}</TableCell>
            <TableCell className={classes.valueCell}>{String(value ?? '')}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
